import { valueFormatterUSD } from "../components/AgGrid/grid-util"
import { myValueFormatter, myValueFormatter_quantity } from "./commonFunctions"
import { TradeStatus } from "./constants"

export const cptyLimitsColDefs = [
    {
      filter: 'agMultiColumnFilter',
      headerName: 'CptyId',
      field: 'cpty_id',
      sortable: true,
      floatingFilter: false,
      valueFormatter: function (params: any) {
        if (params != undefined && params.data != undefined && params.data != null && params.data.cpty_id != null) {
          try {
            return params.data.cpty_id.toUpperCase()
          } catch (e) {}
        }
      },
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        //borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 78,
      maxWidth: 110,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header';
      }
    },
    {
      filter: 'agMultiColumnFilter',
      headerName: 'Cpty Name',
      field: 'cpty_name',
      sortable: true,
      floatingFilter: false,
      editable: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function () {
        return {
          display: 'flex',
          alignItems: 'center',
          //borderRight: '0.5px solid #E1E1E1'
        }
      },
      minWidth: 150,
      maxWidth: 250,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header';
      }
    },
    {
      headerName: 'Borrow Limit',
      field: 'borr_limit',
      sortable: true,
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        //borderRight: '0.5px solid #E1E1E1',
        justifyContent: 'flex-end'
      },
      minWidth: 110,
      maxWidth: 180,
      valueFormatter: valueFormatterUSD,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      headerName: 'Borrow Bal',
      field: 'borr_exposure',
      sortable: true,
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        //borderRight: '0.5px solid #E1E1E1',
        alignItems: 'center',
        justifyContent: 'flex-end'
      },
      minWidth: 110,
      maxWidth: 180,
      valueFormatter: valueFormatterUSD,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
  
    {
      headerName: 'Loan Limit',
      field: 'loan_limit',
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      valueFormatter: valueFormatterUSD,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        //borderRight: '0.5px solid #E1E1E1',
        justifyContent: 'flex-end'
      },
      minWidth: 100,
      maxWidth: 180,
      suppressSizeToFit: false,
      sortable: true,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      headerName: 'Loan Bal',
      field: 'loan_exposure',
      sortable: true,
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        //borderRight: '0.5px solid #E1E1E1',
        justifyContent: 'flex-end'
      },
      minWidth: 110,
      maxWidth: 180,
      valueFormatter: valueFormatterUSD,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
  
    {
      headerName: 'IsBreach',
      field: 'isbreach',
      sortable: true,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        if (params.node.data.isbreach?.toUpperCase() === 'NO' && !params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            color:"green",
            fontWeight:'400'
          }
        }
       else if (params.node.data.isbreach?.toUpperCase() === 'YES' && !params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            color:'rgb(234 79 93)',
            fontWeight:'400'
          }
        }
         else if (params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            // color:TradeStatus.error,
            fontWeight:'400'
          }
        }
      },
      minWidth: 90,
      maxWidth: 150,
      filter: 'agMultiColumnFilter',
      headerClass: function() {
        return 'ag-grid-mui-header';
      }
    },
    {
      headerName: 'Over/UnderBy',
      field: 'over_under_by',
      sortable: true,
      floatingFilter: false,
      valueFormatter: myValueFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: function (params: any) {
        if (params.node.data.over_under_by >= 0 && !params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            color:'rgb(38 112 38)',
            fontWeight:'400'
          }
        } else if (params.node.data.isTotalLabel) {
          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }
        } else
          return {
            display: 'flex',
            alignItems: 'center',
            color:'rgb(234 79 93)',
            justifyContent: 'flex-end',
            fontWeight:'400'
          }
      },
      minWidth: 115,
      maxWidth: 180,
      type: 'rightAligned',
  
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
    {
      headerName: 'Borrow Contracts',
      field: 'borr_contracts',
      sortable: true,
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      hide: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      },
      minWidth: 135,
      maxWidth: 180,
      valueFormatter: myValueFormatter_quantity,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    },
  
    {
      headerName: 'Loan Contracts',
      field: 'loan_contracts',
      sortable: true,
      floatingFilter: false,
      filter: 'agMultiColumnFilter',
      type: 'rightAligned',
      hide: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      },
      minWidth: 125,
      maxWidth: 180,
      valueFormatter: myValueFormatter_quantity,
      suppressSizeToFit: false,
      headerClass: function() {
        return 'ag-grid-mui-header-right-aligned';
      }
    }
  ]